import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CreateStartupForm } from "@/components/startup/CreateStartupForm";
import { SubscriptionCheck } from "@/components/startup/SubscriptionCheck";

const CreateStartup = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      className="container mx-auto py-8 px-4"
    >
      <Card className="max-w-2xl mx-auto bg-flux-black/50 border-flux-cyan/20">
        <CardHeader>
          <CardTitle className="text-2xl text-flux-cyan">Create Your Startup</CardTitle>
        </CardHeader>
        <CardContent>
          <SubscriptionCheck />
          <CreateStartupForm />
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default CreateStartup;